import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Navbar, CustomButton } from '../components';
import './PlanSelectionPage.css';

const BetaExpiredPage = () => {
  const navigate = useNavigate();

  return (
    <div className="plan-selection-page">
      <Navbar navClassName="navbar-beige" />

      <main className="plan-selection-main">
        <div className="plan-selection-container">
          <div className="plan-selection-header">
            <h1>Your beta period has ended</h1>
            <p>
              Thank you for being part of the SayAgain beta. Your Profiles and all your conversations
              are safe — you just need a plan to keep going.
            </p>
          </div>

          <ul className="plan-shared-features">
            <li>All your Profiles and conversations are preserved</li>
            <li>Continue right where you left off</li>
            <li>Cancel anytime</li>
          </ul>

          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <CustomButton
              variant="primary"
              onClick={() => navigate('/select-plan')}
              style={{ padding: '14px 48px', fontSize: '17px', borderRadius: '30px' }}
            >
              Choose a Plan
            </CustomButton>
          </div>

          <p className="plan-selection-footer">
            Questions? Reply to any email from us or write to{' '}
            <a href="mailto:hello@sayagain.ai" style={{ color: 'var(--soft-teal, #6b9ea0)' }}>
              hello@sayagain.ai
            </a>
          </p>
        </div>
      </main>
    </div>
  );
};

export default BetaExpiredPage;
